import { Component } from "@angular/core";
import { PetitumRevisione } from "../../models/petitum-revisione";
import { UtilityCommon } from "../../utils/utility-common";

declare var openModal: any;
@Component({
    selector: 'div [fondo-rischi-revisione-list]',
  templateUrl: 'fondo-rischi-revisione-list.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'', '[attr.id]': '\'fondoRischiRevisioneList\'' }
})

export class FondoRischiRevisioneListComponent {
  lastRevisione: number = 0;
  fondoRischiRevisioniList: PetitumRevisione[] = [];
  calcolaSomma = UtilityCommon.calcolaSomma;

  inizializza(fondoRischiRevisioniList: PetitumRevisione[]) {
    if (fondoRischiRevisioniList.length > 0) {
      openModal('fondoRischiRevisioneList');
      this.fondoRischiRevisioniList = fondoRischiRevisioniList;
      this.lastRevisione = 0;
    }
  }

  sommaFondoRischiControparteAttr(fondoRischiRevisione, attr) {
    let somma = 0;
    fondoRischiRevisione.fondorischiControparti.forEach(el => {
      somma += el[attr];
    });
    return somma;
  }
}
